import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {SimpleDatePicker} from '@hconnect/uikit/src/lib2/components/simpleDatePicker'
import {SxProps, Theme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {Filter, DateRange} from '../../filter.types'

interface DatePickerFilterProps extends Filter<Date | DateRange> {
  rangeAvailable: boolean
  value?: Date | DateRange | null
  translationNamespace?: string
}

export const DatePickerFilter: React.FC<DatePickerFilterProps> = ({
  id,
  label,
  value,
  handleChange,
  rangeAvailable,
  translationNamespace
}) => {
  const {t} = useTranslation(translationNamespace)
  let date: Date | undefined | null = undefined
  let dateRange: DateRange | undefined = undefined

  if (rangeAvailable) {
    if (value && !(value instanceof Date)) {
      dateRange = value
    }
  } else {
    if (value && value instanceof Date) {
      date = value
    } else {
      date = null
    }
  }

  return (
    <SimpleDatePicker
      data-test-id={`datepicker-${id}`}
      fullWidth
      label={t(label)}
      sx={datePickerSx}
      handleRangeChange={rangeAvailable ? handleChange : undefined}
      handleDateChange={!rangeAvailable ? handleChange : undefined}
      date={date}
      dateRange={dateRange}
      showClearButton
    />
  )
}

// Fundamental tokens only. On the legacy blue header a wrapping
// `FilterContrastProvider` swaps in `hpFundamentalContrastTheme`, so these tokens
// resolve to the on-blue colors automatically; Suite keeps the light/dark theme.
const datePickerSx: SxProps<Theme> = (theme) => ({
  height: 58,
  '& > button': {
    borderColor: theme.palette.borderHighlight,
    '&:hover': {
      borderColor: theme.palette.borderHighlight
    },
    '&.Mui-focusVisible, &:focus-visible': {
      borderColor: theme.palette.primary.main
    }
  },
  '& .MuiButton-root:hover': {
    borderColor: `${theme.palette.borderHighlight}!important`
  },
  '& .MuiButton-root.Mui-focusVisible, & .MuiButton-root:focus-visible': {
    borderColor: `${theme.palette.primary.main}!important`
  },
  '& .MuiTypography-root, .MuiSvgIcon-root': {
    color: theme.palette.text.primary
  },
  '& .MuiTypography-h4': {
    fontSize: theme.typography.body2
  },
  '& .MuiTypography-caption': {
    opacity: customThemeConstants().labelOpacity
  },
  '& .MuiIconButton-root': {
    backgroundColor: theme.palette.action.hover,
    ':hover': {
      backgroundColor: theme.palette.action.selected
    }
  }
})
